import { ChangeDetectionStrategy, Component, DestroyRef, inject, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { emailValidator } from '../../common/validators/form.validator';
import { UserService } from '../../services/user.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { SeoService } from '../../services/meta.service';

@Component({
  selector: 'wire-magic-link',
  templateUrl: './magic-link.component.html',
  styleUrls: ['./magic-link.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MagicLinkComponent {

  private readonly userService = inject(UserService);
  private readonly toastr = inject(ToastrService);
  private readonly seoService = inject(SeoService);
  public destroyRef = inject(DestroyRef);
  public cdr = inject(ChangeDetectorRef);

  public loading = false;
  public isSent = false;

  public form = new UntypedFormGroup({
    email: new UntypedFormControl(null, [Validators.required, emailValidator]),
  });

  constructor() {
    this.seoService.setMetaTags({
      title: 'Wire Festival | Magic Link',
      description: 'Wire Festival Magic Link Login',
      keywords: 'Wire Festival Magic Link Login'
    });
  }

  sendMagicLink(): void {
    this.loading = true;
    this.userService.sendMagicLink(this.form.value.email)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.loading = false;
          this.isSent = true;
          this.cdr.detectChanges();
        },
        error: (error) => {
          this.loading = false;
          this.toastr.error(error.error?.message || 'Failed to send magic link');
          this.cdr.detectChanges();
        }
      });
  }
}
